import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { BrandIcon } from './BrandIcon';
import { NavDrawer } from './NavDrawer';

export function AppShell() {
  const { t } = useTranslation();
  // Admin views (dashboard calendar + bookings table) benefit from a wider
  // canvas on desktop than the marketing/public pages need.
  const { pathname } = useLocation();
  const widthClass = pathname.startsWith('/admin') ? 'max-w-7xl' : 'max-w-5xl';

  return (
    <div className="min-h-dvh bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100 flex flex-col">
      <header className="sticky top-0 z-10 bg-white border-b border-slate-200 dark:bg-slate-900 dark:border-slate-700 pt-[env(safe-area-inset-top)]">
        <div className={`mx-auto ${widthClass} px-3 sm:px-6 py-3 flex items-center gap-3 justify-between`}>
          <Link
            to="/"
            className="flex items-center gap-2 font-semibold text-lg tracking-tight"
          >
            <BrandIcon className="w-6 h-6 shrink-0" />
            <span>{t('common.appName')}</span>
          </Link>
          <NavDrawer />
        </div>
      </header>

      <main className={`flex-1 mx-auto w-full ${widthClass} px-3 sm:px-6 py-4 sm:py-6 overflow-x-clip`}>
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 dark:border-slate-800 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] text-center text-xs text-slate-500 dark:text-slate-400">
        <div>
          © {new Date().getFullYear()} {t('common.appName')}
        </div>
        <div className="mt-1 flex flex-wrap justify-center gap-x-3 gap-y-1">
          <a href="mailto:info@baerenfang.ch" className="hover:text-slate-700 dark:hover:text-slate-200">
            info@baerenfang.ch
          </a>
          <a href="tel:+41412448882" className="hover:text-slate-700 dark:hover:text-slate-200">
            041 244 88 82
          </a>
          <Link to="/impressum" className="hover:text-slate-700 dark:hover:text-slate-200">
            {t('nav.impressum')}
          </Link>
          <Link to="/datenschutz" className="hover:text-slate-700 dark:hover:text-slate-200">
            {t('nav.datenschutz')}
          </Link>
        </div>
      </footer>
    </div>
  );
}
